import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const CustomerVideo = ({
  key,
  spotlights=null,
  testimonials=null
}) => {
    const testimonialsLength = (testimonials && testimonials.length > 0) ? testimonials.length - 1 : 0
    const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

    return (
    <>
      <a name="video" />
      <div className="customer-video-block customer_spotlight_block">
        {spotlights && spotlights.map((spotlight) => (
          <div className="bgg1" style={{marginBottom: '-8rem', marginTop: '-8rem'}}>
            <div className="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2 testimonial-static ph0">
              <div className="d-flex flex-wrap">
                <div className={ `col-12 ${spotlight.featuredImage ? "col-md-7 pl0" : ""}  spotlight-inner` }>
                  <div className="quotes">
                    {spotlight.content &&
                      <div className="copy" dangerouslySetInnerHTML={{ __html: spotlight.content }} />
                    }
                    <div className="cust-info mt2">
                      {spotlight.title &&
                        <span className="name">{ htmlDecode(spotlight.title) }</span>
                      }
                      {spotlight.positionTitle &&
                        <span className="position">{ htmlDecode(spotlight.positionTitle) }</span>
                      }
                      <br />
                    </div>
                  </div>
                </div>
                {spotlight.featuredImage &&
                  <div className="col-12 col-md-5 col-xl-4 offset-xl-1 cust-img-wrap">
                    {spotlight.featuredImage.formats?.large &&
                      <img className="cust-img" src={spotlight.featuredImage.formats.large.url.includes(cdnUrl) ? spotlight.featuredImage.formats.large.url : cdnUrl + spotlight.featuredImage.formats.large.url} alt={ spotlight.featuredImage?.alternativeText } style={{zIndex: 0}} />
                    }
                    {!spotlight.featuredImage.formats?.large &&
                      <img className="cust-img" src={spotlight.featuredImage.url.includes(cdnUrl) ? spotlight.featuredImage.url : cdnUrl + spotlight.featuredImage.url} alt={ spotlight.featuredImage?.alternativeText } style={{zIndex: 0}} />
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        ))}

        {testimonials && testimonials.map((testimonial, index) => (
          <div className="container">
            <div className="row">
              <div className="col">
                <div className={ `bs1 bgw ${index === testimonialsLength ? "mb0" : "mv2.5"}` }>
                  <div className="row d-flex aic">
                    {/* WP setup for Resources... */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default CustomerVideo
